import { FC, useState, useEffect } from 'react';
import { TabDesign, TabLayout, Tabs } from '@nextgen-web-framework/all';
import { DownlineTabsProps } from './types/propTypes';
import styles from './DownlineTabs.module.scss';

export const DownlineTabs: FC<DownlineTabsProps> = ({
  tabsData,
  ontabChange,
  isDownlineView,
  selectedTabNumber,
}: DownlineTabsProps) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(selectedTabNumber ?? 0);
  const handleTabSelection = (selectedTab: number) => {
    setSelectedTabIndex(selectedTab);
    ontabChange(selectedTab);
  };

  useEffect(() => {
    if (selectedTabNumber != selectedTabIndex) {
      setSelectedTabIndex(selectedTabNumber ?? 0);
    }
  }, [selectedTabNumber]);

  return (
    <div className={styles['downline-profile-tab-container']}>
      <Tabs
        tabList={tabsData}
        design={TabDesign.PILL}
        layout={TabLayout.HORIZONTAL}
        onTabClick={handleTabSelection}
        selectedTab={selectedTabIndex}
        className={`${styles['downline-profile-tab']} ${isDownlineView && styles['downline-profile-tab-gco']}`}
      />
    </div>
  );
};
